<template>
    <div class="PivotYearManagement">
      <PivotYearManagement/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import PivotYearManagement from '@/components/PivotYearManagement.vue'
  
  export default {
    name: 'admin-PivotYearManagement-view',
    components: {
      PivotYearManagement
    }
  }
  </script>
  